import { Pinia, Store } from 'pinia-class-component';
import { SurveyJsUiClient, SurveyView } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'SurveyStore',
  name: 'SurveyStore',
})
export default class SurveyStore extends Pinia {
  private readonly api = initClient(SurveyJsUiClient);

  //data
  private _loadingPromise: Promise<SurveyView[]> | null = null;
  private _surveys: SurveyView[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get surveys(): SurveyView[] {
    return this._surveys;
  }

  get surveysById(): Map<string, SurveyView> {
    return new Map(this._surveys.map(e => [e.id, e]));
  }

  //actions
  clear(): void {
    this._surveys.splice(0);
  }

  setSurveys(surveys: SurveyView[]): void {
    this._surveys.splice(0);
    this._surveys.push(...surveys);
  }

  rememberSurvey(survey: SurveyView): void {
    const index = this._surveys.findIndex(e => e.id === survey.id);
    if (index >= 0) {
      this._surveys.splice(index, 1, survey);
    } else {
      this._surveys.push(survey);
    }
  }

  forgetSurvey(survey: SurveyView): void {
    const index = this._surveys.findIndex(e => e.id === survey.id);
    if (index >= 0) {
      this._surveys.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.api.list();
      const surveys = await this._loadingPromise;
      this.setSurveys(surveys);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._surveys.length > 0) {
      return;
    }
    return await this.reload();
  }
}